<template>
  <div>
    <HistoryLogCom :fullNode="fullNode"/>

    <table class="detail-table">
      <tbody>
        <tr>
          <td class="label-col">是否需要清洗</td>
          <td>
            <el-tag :type="needUploadFile ? 'success' : 'danger'">
              {{ needUploadFile ? '需要清洗' : '无需清洗' }}
            </el-tag>
          </td>
        </tr>

        <template v-if="fileListLength < 1">
          <tr>
            <td class="label-col">附件</td>
            <td>未上传过附件</td>
          </tr>
        </template>
        <template v-else>
          <tr>
            <td class="label-col">对应客户清单版本</td>
            <td>{{fullNode.project_node.node_result.customer_list_version}}</td>
          </tr>
          <tr>
            <td class="label-col">累计上传次数</td>
            <td>{{fullNode.project_node.node_result.upload_times}}</td>
          </tr>
          <tr>
            <td class="label-col">备注</td>
            <td>{{ fullNode.project_node.node_result.file_remarks }}</td>
          </tr>
          <tr>
            <td class="label-col">附件</td>
            <td>
              <AttachmentViewer :files="fullNode.project_node.node_result.cleaned_files"></AttachmentViewer>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import AttachmentViewer from '@views/project/node-views/AttachmentViewer.vue'
import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom, AttachmentViewer},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {}
  },
  created () {},
  computed: {
    needUploadFile () {
      return this.fullNode.project_node.node_result.need_clear_file
    },
    fileListLength () {
      return _.get(this.fullNode, 'project_node.node_result.cleaned_files', []).length
    },
  },
  watch: {},
  methods: {},
}
</script>

<style scoped>
.detail-table {
  width: 100%;
  margin-top: 15px;
  border-collapse: collapse;
  border: 1px solid #ebeef5;
  table-layout: fixed;
}
.detail-table td {
  padding: 12px 10px;
  border: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
}
.detail-table .label-col {
  width: 120px;
  background-color: #fafafa;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/UploadCleanedFilesView.vue